import { isPlatformServer } from '@angular/common';
import { Injectable, PLATFORM_ID, StateKey, TransferState, inject, makeStateKey } from '@angular/core';
import { Observable, of, tap } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class TransferStateService {
  private transferState = inject(TransferState);
  private platformId = inject<string>(PLATFORM_ID);

  async withStateTransfer<T>(key: string, fn: () => Promise<T>): Promise<T> {
    const KEY = <StateKey<T>>makeStateKey(key);
    let resp: T;
    if (this.transferState.hasKey(KEY)) {
      resp = this.transferState.get<T>(KEY, null);
    } else {
      resp = await fn();
      if (isPlatformServer(this.platformId)) {
        this.transferState.set<T>(KEY, resp);
      }
    }
    return resp;
  }

  withStateTransferObservable<T>(key: string, fn: () => Observable<T>): Observable<T> {
    const KEY = <StateKey<T>>makeStateKey(key);
    if (this.transferState.hasKey(KEY)) {
      return of(this.transferState.get<T>(KEY, null));
    }

    return fn().pipe(
      tap(resp => {
        if (isPlatformServer(this.platformId)) {
          this.transferState.set<T>(KEY, resp);
        }
      })
    );
  }

  withStateTransferInstant<T>(key: string, fn: (...args) => T) {
    const KEY = makeStateKey(key) as StateKey<T>;
    let resp: T;
    if (this.transferState.hasKey(KEY)) {
      resp = this.transferState.get<T>(KEY, null);
    } else {
      resp = fn();
      if (isPlatformServer(this.platformId)) {
        this.transferState.set(KEY, resp);
      }
    }
    return resp;
  }
}
